/**
 * THE PHOTO FALLBACK. What a card's photo box draws when the listing or place
 * has no photograph: a navy tile carrying the place's name in cream display
 * type, with the brokerage's name small beneath it at sizes that can hold it.
 *
 * It never pretends to be a photograph and never draws a grey box, a letter
 * block on wash, or an empty rectangle (site photo pass, Matt 2026-10-25).
 * A card that HAS a photo renders the photo; this is only the else branch.
 *
 * Decorative: the card's own address or name already carries the text, so the
 * tile is aria-hidden and fills whatever positioned box it sits in.
 */
import { cn } from '@/lib/utils'
import './tokens.css'
import './V3PhotoFallback.css'

export type V3PhotoFallbackProps = {
  /** The place the card is about: a town, a community, or the street line. */
  name: string | null | undefined
  className?: string
}

export const V3_PHOTO_FALLBACK_BRAND = 'Ryan Realty'

/** The name the tile prints: trimmed, or the brokerage's when none is filed. */
export function photoFallbackName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim()
  return trimmed || V3_PHOTO_FALLBACK_BRAND
}

export function V3PhotoFallback({ name, className }: V3PhotoFallbackProps) {
  const label = photoFallbackName(name)
  return (
    <span className={cn('v3-photo-fallback', className)} aria-hidden="true">
      <span className="v3-photo-fallback__name">{label}</span>
      {label !== V3_PHOTO_FALLBACK_BRAND ? (
        <span className="v3-photo-fallback__brand">{V3_PHOTO_FALLBACK_BRAND}</span>
      ) : null}
    </span>
  )
}
